import {CardComponentProps} from 'nextstepjs/src/types';

export const OnboardingCard = (_: CardComponentProps) => {
    return null;
};
